<template>
  <div class="content-page-bg">
    <div class="content-page-inner">
      <LandingLoader v-if="loading" />

      <div v-else>
        <div class="content-page-header">
          <span class="content-page-icon"><v-icon size="22" color="#fff">mdi-information-outline</v-icon></span>
          <span class="content-page-eyebrow">Who We Are</span>
        </div>

        <div class="fetched-content-card">
          <!-- API Rendered HTML Content -->
          <div v-if="fetchedContent" v-html="fetchedContent" class="fetched-content-wrapper"></div>

          <!-- Static Fallback Content -->
          <div v-else class="fetched-content-wrapper">
            <h1>About Us</h1>
            <p>
              Details about the SARPA MP initiative and wildlife protection efforts in the state.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LandingLoader from '../components/LandingLoader.vue';

export default {
  name: 'AboutUs',
  components: {
    LandingLoader
  },
  data() {
    return {
      loading: true,
      fetchedContent: null
    };
  },
  mounted() {
    axios.get('/content/get/about_us')
      .then(response => {
        if (response.data && response.data.status && response.data.data && response.data.data.content) {
          this.fetchedContent = response.data.data.content.content;
        }
      })
      .catch(error => {
        console.error('Error fetching About Us content:', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
